<template>
<v-container class="text-center px-5">
  <v-row class="px-5">
    <v-autocomplete
      v-model="user"
      hide-no-data
      hide-selected
      label="By"
      :items="users"
    />
  </v-row>
</v-container>
</template>

<script>
export default {
  name: "OwnerFilterBuilder",
  data() {
    return {
      user: "",
      users: [],
    }
  },
  inject: ["httpClient"],
  async mounted() {
    this.users = (await this.httpClient.loadAllUsers()).map(u => u.name)
  },
  methods: {
    init() {
      this.user = ""
    },

    build(negate) {
      if (!this.user) return [null, "You need to select a user"]
      const prefix = negate ? "not " : ""
      return [`${prefix}owned by ${this.user}`]
    },
  }
}
</script>
